export const processParamsToHeaders = (params) => {
  const newParams = structuredClone(params);
  const headers = {};
  if ("bypassCache" in newParams) {
    if (newParams.bypassCache) headers["X-With-Bypass-Cache"] = 1;
    delete newParams.bypassCache;
  }
  return { headers, params: newParams };
};
